import { lazy, Suspense } from "react";
import { Outlet } from "react-router-dom";
import LayOut from "src/layouts/leadershipBrandSurvey/leadershipBrandSurveyStartPage";
const Disclaimer = lazy(()=> import("src/layouts/leadershipBrandSurvey/leadershipBrandComponents/disclaimer"));

export const leadershipBrandSurveyRoutes = [
    {
        path: "",
        element: (
            <LayOut>
                <Suspense>
                    <Outlet/>
                </Suspense>
            </LayOut>
        ),
        children :[
           { path:"leadershipBrandSurvey",
            index:true,
            element: <Disclaimer/>}
        ]
    }
]